module.exports = __webpack_public_path__ + "static/prepolicycheckup-7ae1cb0e74099a4f26e6ae41475c60eb.jpg";